// import urlPath from 'src/constants/urlPath/urlPath';
import type { INotificationType } from 'src/types/helpdesk/notificationType';
// import type { UserInfo } from 'src/types/master_data/employee.type';
// import { DepartmentEn } from './department.enum';

// const result = localStorage.getItem('userInfo');
// const userInfo: UserInfo = result ? JSON.parse(result) : null;

export const NOTIFICATION_TYPE: INotificationType[] = [];
